import React, { useState, useLayoutEffect, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { UseTranslationProps } from 'types/UseTranslationProps';
import TitleNavBarContext from 'context/TitleNavBarContext';
import SystemNotifyContext from 'context/SystemNotifyContext';
import AddBtn from 'components/AddBtn';
import ListPriceTag from 'components/ListPriceTag';
import { RespTags, PriceTagProps } from 'types/PriceTagProps';
import { getTags } from './reqs';
import FormPriceTag from 'components/FormPriceTag';

export const intialDataListTags = {
	total: 0,
	page: 1,
	limit: 0,
	totalPages: 0,
	data: []
};

export default function PriceTag() {
	const { i18n }: UseTranslationProps = useTranslation();
	const { setDataAbouTitle } = useContext(TitleNavBarContext);
	const { handleNotify } = useContext(SystemNotifyContext);

	const [datalistTags, setDataListTags] =
		useState<RespTags>(intialDataListTags);
	const [tagToEdit, setTagToEdit] = useState<PriceTagProps | null>(null);
	const [isLoad, setIsLoad] = useState(false);
	const [isOpenForm, setIsOpenForm] = useState(false);

	//busca tags do back
	useEffect(() => {
		(async () => {
			setIsLoad(true);

			const { data, isSuccess } = await getTags(
				datalistTags.page,
				handleNotify
			);

			setIsLoad(false);

			if (isSuccess && data) {
				setDataListTags(data);
			}
		})();
	}, [datalistTags.page]);

	//muda titulo do componente
	useLayoutEffect(() => {
		setDataAbouTitle((value) => ({
			...value,
			title: 'Etiquetas promocionais'
		}));
	}, [i18n?.language]);

	return (
		<S.container>
			<AddBtn
				anyFunction={() => {
					setIsOpenForm(true);
				}}
				text="Adicionar etiqueta"
			/>

			<ListPriceTag
				isLoad={isLoad}
				datalistTags={datalistTags}
				setDataListTags={setDataListTags}
				setTagToEdit={setTagToEdit}
				setIsOpenForm={setIsOpenForm}
			/>

			{isOpenForm && (
				<FormPriceTag
					isOpenForm={isOpenForm}
					setIsOpenForm={setIsOpenForm}
					tagToEdit={tagToEdit}
					setTagToEdit={setTagToEdit}
					datalistTags={datalistTags}
					setDataListTags={setDataListTags}
				/>
			)}
		</S.container>
	);
}
